module.exports = __webpack_public_path__ + "static/media/Academy of Gp Orthodontics Logo.d91a20b4.jpeg";